import { dashboardPosModule } from '../PosModules/moduleFeatures';

export const defaultDishWasherPermission = [
  {
    id: 3455,
    roleId: 16,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3456,
    roleId: 16,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3457,
    roleId: 16,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3458,
    roleId: 16,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3474,
    roleId: 16,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const dishWasherPosDefaultPermission = [dashboardPosModule['my-day-visible']];
